import { PartnerId } from '../../../models/Integration';

const getPartnerIdFromIntegrationKey = (integrationKey: string): PartnerId => {
  const [partnerId] = integrationKey.split('.');
  return partnerId as PartnerId;
};

export { getPartnerIdFromIntegrationKey };
